module.exports = __webpack_public_path__ + "img/22.9ea0f3f2.webp";